import { render, staticRenderFns } from "./EditReadyWhen.vue?vue&type=template&id=915aba18&"
import script from "./EditReadyWhen.vue?vue&type=script&lang=ts&"
export * from "./EditReadyWhen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915aba18')) {
      api.createRecord('915aba18', component.options)
    } else {
      api.reload('915aba18', component.options)
    }
    module.hot.accept("./EditReadyWhen.vue?vue&type=template&id=915aba18&", function () {
      api.rerender('915aba18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/discharge/EditReadyWhen.vue"
export default component.exports